import { Component, OnInit } from '@angular/core';
import {User, UsersService} from "@hassel-it/angular-common";
import {ActivatedRoute} from "@angular/router";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-control-dashboard',
  templateUrl: './control-dashboard.component.html',
  styleUrls: ['./control-dashboard.component.scss']
})
export class ControlDashboardComponent implements OnInit {


    public user: User;

    constructor(
        public activatedRoute: ActivatedRoute,
        public usersService: UsersService,
        public ngbModal: NgbModal) {
    }

    ngOnInit() {
        this.usersService.getCurrentUser().then(user => {
            this.user = user;

        });
    }
}
